import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import GroupFormFields from "./GroupFormFields.js";


class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.grupos.delete}
                postUrl={api.usuarios.grupos.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Grupo ha sido eliminado con éxito."}
                notAllowedMessage={"El Grupo no puede ser eliminado ya que se encuentra en uso por Usuarios del sistema."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Grupo"}
                buttonTitle={"Eliminar Grupo"}
                buttonIcon={"fa fa-trash fa-lg"}
                
                saveButton={true}
                closeButton={true}
                danger={true}
                buttonClass={"btn-danger"}
                saveButtonLabel={"Eliminar"}
                className={"ui-modal-dialog"}>
                <div className="ui-form">
                    <div className="ui-alert ui-alert-danger">
                        <i className="ti ti-trash" aria-hidden="true"></i>
                        Se eliminará el grupo seleccionado.
                    </div>
                    <GroupFormFields disabled={true} />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Grupos/Delete.js